export default __webpack_public_path__ + "static/media/feelings.531c664e.svg";